import { render } from "./RecentDiscountTransactionItem.vue?vue&type=template&id=2c3bae99&scoped=true"
import script from "./RecentDiscountTransactionItem.vue?vue&type=script&lang=js"
export * from "./RecentDiscountTransactionItem.vue?vue&type=script&lang=js"

import "./RecentDiscountTransactionItem.vue?vue&type=style&index=0&id=2c3bae99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3bae99"]])

export default __exports__